import { useMutation } from "@tanstack/react-query";
import { loginApi } from "components/api/user";
import { useAuthContext } from "components/context/authContext";
import Login from "components/view/login";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  alertControl,
  emailRegex,
  regPassword,
  successControl,
} from "util/commAction";

export default function LoginPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { lodInf } = useAuthContext();

  const { viewPort, userInf, onIsLoggedIn, onUserInf } = useAuthContext();

  const [emlId, setEmlId] = useState("");
  const [lgnPwd, setLgnPwd] = useState("");

  const handleChange = (name: string, value: string) => {
    if (name === "emlId") {
      setEmlId(value);
      return;
    }
    if (name === "lgnPwd") {
      setLgnPwd(value);
    }
  };
  const loginMutation = useMutation({
    mutationFn: loginApi,
    onSuccess: (res) => {
      if (res) {
        const { status, data } = res;

        successControl({
          status: status,
          success: () => {
            onIsLoggedIn(true);
            onUserInf({
              ...userInf,
              ...res.data,
              emlId,
            });

            navigate(state?.prevPath || "/" + lodInf?.lodNo, {});
          },
        });
      }
    },
  });
  const handleLogin = () => {
    // api 로그인 통신

    if (!(emlId || emailRegex.test(emlId))) {
      alertControl({
        isOpen: true,
        inner: "정확한 형식의 이메일주소를 입력하여 주세요.",
      });

      return;
    }

    if (!(lgnPwd || regPassword.test(lgnPwd))) {
      alertControl({
        isOpen: true,
        inner: "정확한 형식의 비밀번호를 입력하여 주세요",
      });

      return;
    }

    // login api
    loginMutation.mutate({
      emlId,
      lgnPwd,
    });
  };

  useEffect(() => {
    const emlId = localStorage.getItem("emlId");

    if (emlId) {
      setEmlId(emlId);
    }
  }, []);

  //ENTERKEY LOGIN
  // const handleEnterLogin = (event: KeyboardEvent) => {
  //   if (event.key == "Enter") {
  //     handleLogin();
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("keydown", handleEnterLogin);
  //   return () => {
  //     windowNaNpxoveEventListener("keydown", handleEnterLogin);
  //   };
  // }, []);

  return (
    <>
      <Login
        styles={"login-" + viewPort?.screen + ""}
        emlId={emlId}
        lgnPwd={lgnPwd}
        handleChange={handleChange}
        handleLogin={handleLogin}
      />
    </>
  );
}
